export const PRIMARY_COLOR = "#001489";
export const SECONDARY_COLOR = "#232222";
export const SUB_COLOR = "#ffcc00";
export const LARGE_FONT_SIZE = "16px";
export const MED_FONT_SIZE = "0.875rem";
export const SMALL_FONT_SIZE = "12px";
export const COPYRIGHT_MESSAGE = "Copyright © 2024. All rights reserved";
export const CREATE_MSG = "DEBI Create";
export const CREATE_REQ = "DEBI Request";
export const DEBI_DETAILS_MSG = "Details";
export const DEBI_STATUS_LABEL = "Select DEBI status";
export const MAINTENANCE_DC_LABEL = "Select Distribution Center";
export const MAINTENANCE_STORE_LABEL = "Select Store";
export const INSTALLER_MSG = "Installer Information";
export const DEBI_PARTS_MSG = "Parts";
export const DEBI_NOTES = "Notes";
export const DATE_ERR_MSG = "From Date cannot be greater than to Date";
export const DEBI_AGREEMENT_ACCEPTANCE_TEXT =
  "Installer Agreement and Acceptance";
export const DEBI_REQ_SIG = "Required Signatures";
export const DEBI_PROCESS_APPROVE_MSG =
  "Review and Approve for Processing: Incomplete DEBIs cannot be processed. To ensure timely processing, please review the information and sign your request. Once you are done, choose Submit.";
export const DEBI_REQ_SIG_TEXT =
  "Please populate your Agent, DC Name, Rep Name and their correct email addresses. Verify the email address before saving the record. If the email address is incorrect, the person will not get an email letting them know their signature is required which will delay processing. Once you are done, choose SAVE, then SUBMIT for Signatures.";
export const DEBI_SIGN_MSG =
  "By signing, I have read and agree to the installer terms.";
export const DEBI_AGREEMENT_MSG =
  "Installer acknowledges receipt of the items listed on the front of form in the quantities and costs noted for the initial stock, plus the rack and signage material. These batteries will be invoiced and established as a separate deferred billing to the Installer, not currently payable. Installer agrees to hold items in his place of business bearing the risk of damage, loss or local taxes. Payment for the initial stock, which may be modified from time to time, will remain deferred as long as the stock is: maintained properly and has a minimum of 4 turns per year. remains as new inventory in an unused condition. It is understood that the deferred billing will continue for the battery assortment as itemized on this form as long as the Installer maintains a good credit standing with the NAPA Store and achieves a minimum of 1 turn per quarter. It is further understood that the Installer will pay for any battery sold from the stock assortment. All deferred account adjustments to the initial stock will be at the current prices. The battery rack will remain the property of the NAPA Auto Parts Store. The NAPA Auto Parts Store will replenish the assortment on a weekly basis, or as often as required to maintain inventory in a saleable condition. Billing on product replenishment will be at the standard terms from the NAPA Auto Parts Store based on the current dealer outright, less scrap battery value, when a scrap battery is returned.";
export const DEBI_ADD_PARTS_MSG =
  "Add your Part Details.";
export const INSTALLER_INFO_MSG =
  "Populate your information and your Installer Information. This information is required to proceed.";
export const SELECT_LABEL = "Select";
export const CANCEL_LABEL = "Cancel";
export const EDIT = "Edit";
export const DECRYPT_KEY = "d_11";
export const REMOVE_VALUE_LABEL = "Remove Value";
export const LOOKUP_LABEL = "LookUp Records";
export const CLICK_AND_SELECT_LABEL =
  "Choose one record and click Select to continue.";
export const MAINTENANCE_TITLE = "Hello Mellisa";
export const SOMETHING_WENT_WRONG_TEXT = "Something went wrong";
export const LOGIN_FAILED_ERR = "Login Failed LogOut & Try Later...";
export const NO_ROLE_ERR = "Permission Denied,No Access to Application.";
export const DEL_ERR = "Are you sure you want to delete this record ?";
export const CANCEL_MSG = "Are you sure you want to cancel this record ?";
export const REVISE_MSG = "Are you sure you want to revise your changes?";
export const SUBMIT_MSG = "Are you sure you want to submit your changes?";
export const EDIT_MSG ="Editing this Debi Contract will invalidate all existing approvals and initiate a new approval cycle. Are you sure you want to modify this record?";
export const NO_DATA_FOUND_TEXT = "No data found.";
export const PART_REQ_FIELD = "Part is a required field."
export const PART_ALREADY_ADDED_MSG = "Part already added to the DEBI Request. Please update that record."
export const QTY_REQ_MSG = "Quantity is a required field."
export const TOT_QTY_EXCEED_MSG = "Total quantity cannot exceed 18."
export const QTY_VALIDATION_MSG = "Quantity should be numeric and length should be 2."
export const COOKIE_KEY = "d_12";
export const HOME_TEXT = "Home";
export const DEBI_REQUEST_TEXT = "DEBI Request";
export const CODE_COOKIE = "code_verifier";
export const ADD_PARTS = "Add Parts";
export const DELETE_PART = "Delete Parts";
export const UPDATE_PARTS = "Update Parts";
export const UPDATE_LABEL = "Update";
export const DELETE_LABEL = "Delete";
export const CLICK_HERE_LABEL = "Click here";
export const NAPA_BATTERY_TITLE = "NAPA BATTERIES";
export const SELECT_REPORT_TEXT = "Select Report";
export const SELECT_STATUS_TEXT = "Select Status";
export const SELECT_DC_TEXT = "Select DC";
export const USERS_LABEL = "Users";
export const DC_ACQ = "DC Acquired";
export const DEBI_REGI = "DEBI Registration";
export const DEBI_EDIT_HIST = "DEBI History Edit";
export const PART_SALES_SUM = "Parts Summary Report"
export const DEBI_RAW_DATA = "DEBI Raw Data";
export const FROM_LABEL = "Start Date"
export const TO_LABEL = "End Date"
export const EXPORT_LABEL = "Export";
export const SOMETHING_WENT_WRONG_API = "Something Went Wrong. Please try again later."
export const BAD_REQUEST = "Bad Request."
export const UNAUTHORISED = "Unauthorized."
export const NOT_FOUND = "API Not Found."
export const PLEASE_WAIT_MESSAGE="Downloading... Please Wait";
export const SUPPRESSED_WARNINGS = [
  "validateDOMNesting(...): <div> cannot appear as a child of <tbody>"
];
export const MORE_INFO_TEXT = " For more info about user On-boarding visit :";
export const AUTH_TEXT = "To authenticate, please enter your GPC Employee Number as yourusername and your GPC password. For additional security,authentication will be completed through PingID."
export const REDIRECT_URL = 'https://gpcprod.atlassian.net/wiki/spaces/COMPLATFORM/pages/1758298406/User+Onboarding+and+Access+Requirements';
export const MAIL_CLIENTS = [
  { client: "gmail", src: require("../../assets/images/gmail1.png") ,testid:"gmail" },
  { client: "outlook", src: require("../../assets/images/outlook-logo.png") , testid:"outlook" },
];
export const GMAIL = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=napabatteriesdebi@genpt.com?subject=${encodeURIComponent(
  "NapaBatteries%20Debi%20tool%20:%20Feedback"
)}`;
export const OUTLOOK = `https://outlook.office.com/mail/deeplink/compose?to=napabatteriesdebi@genpt.com?subject=${encodeURIComponent(
  "NapaBatteries%20Debi%20tool%20:%20Feedback"
)}`;

//style constants
export const ROW_FLEX = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
};
export const MAIL_ASSET_STYLE = {
  height: "100px",
  width: "100px",
  cursor: "pointer",
  marginRight: "20px",
};
export const FEEDBACK_BTN_STYLE = {
  marginTop: "40px",
  width: "100px",
  position: "fixed",
  zIndex: "1",
  right: "-80px",
  transform: "translateX(0%) translateY(-280%) rotate(90deg)",
  transformOrigin: "left",
  bottom: "45%",
};
export const NAVBAR_STYLE_MD = {
  mr: 2,
  display: { xs: "none", md: "flex" },
  fontFamily: "monospace",
  fontWeight: 700,
  letterSpacing: ".3rem",
  color: "inherit",
  textDecoration: "none",
}
export const MT_25 = { marginTop: "25px" };
export const REPORT_STYLE = { marginTop: "15px", fontFamily: "my-font",marginBottom:"15px" }
export const COLOR_BLACK = { color: "black" }
export const NAVBAR_STYLE_XS_BOX = { flexGrow: 1, display: { xs: "flex", md: "none" } }
export const NAVBAR_STYLE_XS_MENU = {
  display: { xs: "block", md: "none" },
  color: SUB_COLOR,
}

export const ML_CURSOR_POINTER = { flexGrow: 0, marginLeft: "0.7%", cursor: "pointer" }
export const NAVBAR_TYPO = {
  my: 2,
  color: SUB_COLOR,
  fontSize: '0.9rem'
}
export const MR_ML_COLOR = {
  color: SUB_COLOR,
  marginRight: "10px",
  marginLeft: "5px",
};
export const NAVBAR_STYLE_MD_BOX = {
  flexGrow: 1,
  justifyContent: "flex-end",
  display: { xs: "none", md: "flex" },
}
export const COLOR_FFF = { color: "#fff" };
export const APPBAR_STYLES = {
  height: "60px !important",
  backgroundColor: `${PRIMARY_COLOR} !important`,
  color: SUB_COLOR,
};
export const FORM_FONT_STYLE = {
  fontWeight: "bold",
};

export const cursorPointerRelPos = { cursor: "pointer", position: "relative" };
export const partTableStyles = {
  position: "absolute",
  backgroundColor: "white",
  padding: "10px",
  boxShadow: "6px 6px 9px #b6bfbf, -6px -6px 9px #edfbfafa",
  zIndex: 10,
  width: "90px",
  fontSize: "16px",
};
export const LOGIN_FAILIED_STYLE = {
  fontSize: 32,
  fontWeight: 600,
};
export const TABLE_CELL_STYLE = {
  fontFamily: "my-font",
  fontWeight: 600,
  paddingLeft: "19px !important",
};
export const FONT_WEIGHT_600 = { fontFamily: "my-font", fontWeight: 600 };
export const CONTAINER_STYLE = { display: "flex", justifyContent: 'space-between' }
export const WIDTH_100 = { width: "100%" }
export const BORDER_TOP = { borderTop: ".3rem solid #ddd" };
export const BORDER_BOTTOM = { borderBottom: "1px solid #ddd" };
export const LIST_ITEM_STYLE = {
  fontWeight: "700",
  width: "8rem",
  wordBreak: "normal",
  float: "left",
};
export const LIST_ITEM_BOX = {
  fontWeight: "300",
  paddingLeft: "12%",
  textAlign: "justify",
  width: "50%",
}
export const DEBI_ROLE = {
  SALES_REP: 'SaleRep',
  STORE_AGENT: 'StoreAgent',
  DC_CONTACT: 'DC_contact',
  PARTS_ADMIN: 'PartsAdmin'
};
export const SOURCE = {
  DC: "dc",
  MAIN: "main",
  PARTSINSIDE: "partsInside",
  STORE: "store",
  PARTS_MAINTENANCE: "parts-maintenance",
  PARTS: "parts",
  INPROGRESS: "main-In Progress DEBI Requests",
  CANCELLED: "main-Cancelled DEBI 's",
  HISTORY: "main-DEBI History",
};
export const DEBI_REQUEST = {
  DRAFT: "Draft DEBI Requests",
  PENDING: "Pending DEBI Requests",
  OPEN: "Open DEBI 's",
  INPROGRESS: "In Progress DEBI Requests",
  CANCELLED: "Cancelled DEBI 's",
  HISTORY: "DEBI History",
  INCOMPLETE:"Incomplete DEBI Requests"
};
export const LABEL_MAP = {
  DIS_CENTER: "Distribution Center",
  STORE: "Store",
  DEALER_NUM: "Dealer Number",
  BNAME: "Business Name",
  TEL: "Telephone",
  STREET_ADDRESS: "Street Address",
  INSTALLER_EMAIL: "Installer Email",
  CITY: "City",
  STATE: "State",
  ZIPCODE: "Zip Code",
};

export const VALIDATIONS = {
  DC_NAME_LENGTH: "D.C. Name should be of length 60",
  INSTALLER_NAME_LENGTH: "Installer Name should be of length 60",
  DC_EMAIL_LENGTH: "D.C. Email should be of length 60",
  DC_EMAIL_VALID: "D.C. Email must be a valid email address",
  STORE_AGENT_LENGTH: "Store Agent should be of length 60",
  STORE_AGENT_EMAIL: "Store Agent Email should be of length 60",
  STORE_AGENT_EMAIL_VALID: "Store Agent Email must be a valid email address",
  QTY_VALIDATION: "Add your Part Details, selecting up to a maximum of 18 total units.",
  DC_STORE_EMAIL_DUPE: "D.C. email and Store Agent email should not be the same",
  DC_INSTALLER_EMAIL_DUPE: "D.C. email and Installer email should not be the same",
  DC_STORE_INSTALLER_EMAIL_DUPE: "Installer email,Store Agent email and D.C. email should not be the same",
  DC_STORE_SALESREP_INSTALLER_EMAIL_DUPE: "SalesRep email,Installer email,Store Agent email and D.C. email should not be the same",
  STORE_INSTALLER_EMAIL_DUPE: "Store Agent email and Installer email should not be the same",
  STORE_AGENT_EMAIL_REQUIRED: "Store Agent email is a required field",
  SALEREP_STORE_EMAIL_DUPE: "Store Agent email and SalesRep email should not be the same",
  SALEREP_DC_EMAIL_DUPE: "D.C. email and SalesRep email should not be the same",
  SALEREP_INSTALLER_EMAIL_DUPE :"Installer email and SalesRep email should not be the same",
  STORE_AGENT_REQUIRED: "Store Agent is a required field",
  DC_EMAIL_REQUIRED: "D.C. Email is a required field",
  DC_NAME_REQUIRED: "D.C. Name is a required field",
  INSTALLER_NAME_REQUIRED: "Installer Name is a required field"
};

export const REPORT = {
  TOP_PRODUCT: "TOP_PRODUCTS",
  DC_ACQUIRED: "DC_ACQUIRED",
  DEBI_REGISTRATION: "DEBI_REGISTRATION",
  DEBI_EDIT_HISTORY: "DEBI_EDIT_HISTORY",
  PART_SALES_SUMMARY: "partsAndDebiReport",
  DC_ACQUIRED_MSG: "This report will list all Distribution Centers that have Debi contracts.",
  USER_MSG: "This report will have the unique user list within the selected date range.",
  TOP_MSG: "This report ranks part numbers by the total quantity of contracts created, with the highest-quantity part numbers listed first",
  DEBI_RAW_MSG: "Export DEBI Raw data based on Status of DEBI and DEBI's Created date.",
  DEBI_EDIT_HISTORY_MSG: "Export DEBI effective dates and the last modified information,showing when the DEBI was updated and by whom for tracking changes over time.",
  PART_SALES_SUMMARY_MSG: "Export specific part details appear in number of DEBIs and total are deferred."
}
export const DEBOUNCE_STYLE = {
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: "1.4375em",
  letterSpacing: "0.00938em",
  color: "rgba(0, 0, 0, 0.87)",
  boxSizing: "border-box",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  position: "relative",
  borderRadius: "4px",
  height: "1.4375em",
  padding: "10px",
  paddingTop: "20px",
  paddingBottom: "20px",
  border: "1px solid lightgray",
}
export const DISPLAY_FLEX = { display: 'flex' }
export const BACKGROUND_COLOR = { backgroundColor: "rgb(229, 231, 243)" }
export const BORDER_RADIUS_4PX = { borderRadius: "4px" }
export const BORDER_1PX_SOLID = { border: "1px solid #919a9c" }
export const EDIT_ROLE_STYLE = { borderBottom: "1px solid #919a9c", marginTop: "25px", color: 'black' }
export const EDIT_ROLE_TEXT = { fontWeight: '600', marginTop: '15px' }
export const MT_25px = { marginTop: "25px" }
export const COLOR_RED = { color: "red" }
export const MT_4PX = { marginTop: "4px" }
export const DEBI_DETAILS_GRIDITEN_STYLE = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginTop: "40px",
}
export const COLOR_GREEN = { color: "green" }
export const VALIDATION_MSG_STYLE = { height: "10px", marginTop: "5px", paddingTop: '5px' }
export const VALIDATION_MSG_STYLE1 = {
  height: "10px",
  marginTop: "10px",
  paddingTop: "7px",
}
export const DELETE_BTN_CONTAINER_STYLE = { display: 'flex', justifyContent: 'flex-end', margin: "10px" }
export const MARGIN_10PX = { margin: "10px" }
export const HEIGHT_30PX = { height: "30px" }